<template>
  <div id="app">
    <router-view />
    <div id="element">
      <div id="recaptcha-element" style="display:none;"></div>
    </div>
    <InactiveMemberInform/>
  </div>
</template>

<script>
import InactiveMemberInform from "@/components/auth/InactiveMemberInform.vue";
export default {
  components: {
    InactiveMemberInform
  }
};
</script>

<style>
#app {
  max-width: var(--max-width-app);
  margin-left: auto;
  margin-right: auto;
}
</style>
